import produce from 'immer'
import {
  PROJECT_ALERTS_LOAD,
  PROJECT_ALERTS_LOAD_SUCCESS,
  PROJECT_ALERTS_LOAD_FAIL
} from './actions'

const initialState = {
  loading: false,
  error: null,
  data: {}
}

export const reducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case PROJECT_ALERTS_LOAD: {
        draft.loading = true
        draft.error = null
        return
      }
      case PROJECT_ALERTS_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.data = action.alerts
        return
      }
      case PROJECT_ALERTS_LOAD_FAIL: {
        draft.loading = false
        draft.error = action.error
        return
      }
      default:
        return
    }
  })
